import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("PurchaseStore");

const urls = {
  purchase: (id) => `/bnpl/purchase/merchant/${id}`,
};

const initState = () => {
  return {
    purchase: {},
  };
};

const actions = {
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.purchase(id));
      commit("savePurchase", { data: data, id: id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  savePurchase: (state, { data, id }) => {
    Vue.set(state.purchase, id, data);
  },
};

const getters = {
  get: (state) => (id) => {
    return state.purchase[id];
  },
};
export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
